import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { dateToString } from '@/utils';
import { useGetChildActivitiesQuery } from '@/services/child-api';
import Table from '@/components/table';

// The Add button was removed: adding an activity by hand didn't update the task list or open tasks.
const Activity = ({ childId }) => {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const pageNumber = queryParams.get('page') || 1;
  const { data, isFetching } = useGetChildActivitiesQuery({ childId, pageNumber });

  const columns = [
    {
      title: 'Activity',
      dataIndex: 'type',
      render: (value, record) => (
        <>
          {value.name}
          {record.statusReason && record.statusReason.name && (
            <div>
              <i>
                <strong>Reason:</strong> {record.statusReason.name}
              </i>
            </div>
          )}
        </>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'activity',
      width: 300,
      render: (value) => {
        const startDateString = dateToString(value.start);

        if (value.end) {
          const endDateString = dateToString(value.end);

          const start = new Date(value.start);
          const end = new Date(value.end);
          const differenceInTime = end.getTime() - start.getTime();
          const differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24)) + 1;

          return (
            <>
              {`${startDateString} to ${endDateString} `}
              <i>
                ({differenceInDays} day{differenceInDays > 1 ? 's' : ''})
              </i>
            </>
          );
        }

        return startDateString;
      },
    },
    {
      title: 'Note',
      dataIndex: 'note',
      ellipsis: true,
    },
    {
      title: 'User',
      dataIndex: 'createUser',
      ellipsis: true,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      rowKey="childActivityId"
      loading={isFetching}
      pageInfo={data}
      size="small"
    />
  );
};

export default memo(Activity);
